var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
/**
 * Reads a query param once on mount and removes it from the URL via
 * history.replace, so the history entry no longer carries the flag
 * (e.g. returning to the page with the back button won't re-trigger it).
 */
export var useConsumeQueryParam = function (param) {
    var history = useHistory();
    var location = useLocation();
    var consumedValueRef = useRef(new URLSearchParams(location.search).get(param));
    useEffect(function () {
        var queryParams = new URLSearchParams(history.location.search);
        if (queryParams.has(param)) {
            queryParams.delete(param);
            history.replace(__assign(__assign({}, history.location), { search: queryParams.toString() }));
        }
    }, [history, location.search, param]);
    return consumedValueRef.current;
};
